export const GENERIC_ERROR = {
  TITLE: 'Erro ao Carregar Dados',
  DESCRIPTION: 'Entre em contato com o Administrador do Sistema.'
};

export const MESSAGE_NO_DATA_TO_DISPLAY = 'Não há nenhum registro para mostrar.';
export const MESSAGE_NO_FILTERED = 'Clique em pesquisar.';

export const statusImageSite = {
  0: '',
  1: 'Pendente',
  2: 'Validado',
  3: 'Negado'
};

export const timezones = [
  'Europe/Andorra',
  'Asia/Dubai',
  'Asia/Kabul',
  'America/Puerto_Rico',
  'America/Antigua',
  'America/Puerto_Rico',
  'America/Anguilla',
  'Europe/Tirane',
  'Asia/Yerevan',
  'Africa/Lagos',
  'Africa/Luanda',
  'Antarctica/Casey',
  'Antarctica/Davis',
  'Antarctica/Mawson',
  'Antarctica/Palmer',
  'Antarctica/Rothera',
  'Antarctica/Troll',
  'Antarctica/Vostok',
  'Pacific/Auckland',
  'Pacific/Port_Moresby',
  'Asia/Riyadh',
  'Antarctica/McMurdo',
  'Antarctica/DumontDUrville',
  'Antarctica/Syowa',
  'America/Argentina/Buenos_Aires',
  'America/Argentina/Cordoba',
  'America/Argentina/Salta',
  'America/Argentina/Jujuy',
  'America/Argentina/Tucuman',
  'America/Argentina/Catamarca',
  'America/Argentina/La_Rioja',
  'America/Argentina/San_Juan',
  'America/Argentina/Mendoza',
  'America/Argentina/San_Luis',
  'America/Argentina/Rio_Gallegos',
  'America/Argentina/Ushuaia',
  'Pacific/Pago_Pago',
  'Europe/Vienna',
  'Australia/Lord_Howe',
  'Antarctica/Macquarie',
  'Australia/Hobart',
  'Australia/Melbourne',
  'Australia/Sydney',
  'Australia/Broken_Hill',
  'Australia/Brisbane',
  'Australia/Lindeman',
  'Australia/Adelaide',
  'Australia/Darwin',
  'Australia/Perth',
  'Australia/Eucla',
  'America/Puerto_Rico',
  'America/Aruba',
  'Europe/Helsinki',
  'Europe/Mariehamn',
  'Asia/Baku',
  'Europe/Belgrade',
  'Europe/Sarajevo',
  'America/Barbados',
  'Asia/Dhaka',
  'Europe/Brussels',
  'Africa/Abidjan',
  'Africa/Ouagadougou',
  'Europe/Sofia',
  'Asia/Qatar',
  'Asia/Bahrain',
  'Africa/Maputo',
  'Africa/Bujumbura',
  'Africa/Lagos',
  'Africa/Porto-Novo',
  'America/Puerto_Rico',
  'America/St_Barthelemy',
  'Atlantic/Bermuda',
  'Asia/Kuching',
  'Asia/Brunei',
  'America/La_Paz',
  'America/Puerto_Rico',
  'America/Kralendijk',
  'America/Noronha',
  'America/Belem',
  'America/Fortaleza',
  'America/Recife',
  'America/Araguaina',
  'America/Maceio',
  'America/Bahia',
  'America/Sao_Paulo',
  'America/Campo_Grande',
  'America/Cuiaba',
  'America/Santarem',
  'America/Porto_Velho',
  'America/Boa_Vista',
  'America/Manaus',
  'America/Eirunepe',
  'America/Rio_Branco',
  'America/Toronto',
  'America/Nassau',
  'Asia/Thimphu',
  'Africa/Maputo',
  'Africa/Gaborone',
  'Europe/Minsk',
  'America/Belize',
  'America/St_Johns',
  'America/Halifax',
  'America/Glace_Bay',
  'America/Moncton',
  'America/Goose_Bay',
  'America/Toronto',
  'America/Iqaluit',
  'America/Winnipeg',
  'America/Resolute',
  'America/Rankin_Inlet',
  'America/Regina',
  'America/Swift_Current',
  'America/Edmonton',
  'America/Cambridge_Bay',
  'America/Inuvik',
  'America/Dawson_Creek',
  'America/Fort_Nelson',
  'America/Whitehorse',
  'America/Dawson',
  'America/Vancouver',
  'America/Panama',
  'America/Puerto_Rico',
  'America/Phoenix',
  'America/Blanc-Sablon',
  'America/Atikokan',
  'America/Creston',
  'Asia/Yangon',
  'Indian/Cocos',
  'Africa/Maputo',
  'Africa/Lagos',
  'Africa/Kinshasa',
  'Africa/Lubumbashi',
  'Africa/Lagos',
  'Africa/Bangui',
  'Africa/Lagos',
  'Africa/Brazzaville',
  'Europe/Zurich',
  'Africa/Abidjan',
  'Pacific/Rarotonga',
  'America/Santiago',
  'America/Punta_Arenas',
  'Pacific/Easter',
  'Africa/Lagos',
  'Africa/Douala',
  'Asia/Shanghai',
  'Asia/Urumqi',
  'America/Bogota',
  'America/Costa_Rica',
  'America/Havana',
  'Atlantic/Cape_Verde',
  'America/Puerto_Rico',
  'America/Curacao',
  'Asia/Bangkok',
  'Indian/Christmas',
  'Asia/Nicosia',
  'Asia/Famagusta',
  'Europe/Prague',
  'Europe/Zurich',
  'Europe/Berlin',
  'Europe/Busingen',
  'Africa/Nairobi',
  'Africa/Djibouti',
  'Europe/Berlin',
  'Europe/Copenhagen',
  'America/Puerto_Rico',
  'America/Dominica',
  'America/Santo_Domingo',
  'Africa/Algiers',
  'America/Guayaquil',
  'Pacific/Galapagos',
  'Europe/Tallinn',
  'Africa/Cairo',
  'Africa/El_Aaiun',
  'Africa/Nairobi',
  'Africa/Asmara',
  'Europe/Madrid',
  'Africa/Ceuta',
  'Atlantic/Canary',
  'Africa/Nairobi',
  'Africa/Addis_Ababa',
  'Europe/Helsinki',
  'Pacific/Fiji',
  'Atlantic/Stanley',
  'Pacific/Kosrae',
  'Pacific/Port_Moresby',
  'Pacific/Guadalcanal',
  'Pacific/Chuuk',
  'Pacific/Pohnpei',
  'Atlantic/Faroe',
  'Europe/Paris',
  'Africa/Lagos',
  'Africa/Libreville',
  'Europe/London',
  'America/Puerto_Rico',
  'America/Grenada',
  'Asia/Tbilisi',
  'America/Cayenne',
  'Europe/London',
  'Europe/Guernsey',
  'Africa/Abidjan',
  'Africa/Accra',
  'Europe/Gibraltar',
  'America/Nuuk',
  'America/Danmarkshavn',
  'America/Scoresbysund',
  'America/Thule',
  'Africa/Abidjan',
  'Africa/Banjul',
  'Africa/Abidjan',
  'Africa/Conakry',
  'America/Puerto_Rico',
  'America/Guadeloupe',
  'Africa/Lagos',
  'Africa/Malabo',
  'Europe/Athens',
  'Atlantic/South_Georgia',
  'America/Guatemala',
  'Pacific/Guam',
  'Africa/Bissau',
  'America/Guyana',
  'Asia/Hong_Kong',
  'America/Tegucigalpa',
  'Europe/Belgrade',
  'Europe/Zagreb',
  'America/Port-au-Prince',
  'Europe/Budapest',
  'Asia/Jakarta',
  'Asia/Pontianak',
  'Asia/Makassar',
  'Asia/Jayapura',
  'Europe/Dublin',
  'Asia/Jerusalem',
  'Europe/London',
  'Europe/Isle_of_Man',
  'Asia/Kolkata',
  'Indian/Chagos',
  'Asia/Baghdad',
  'Asia/Tehran',
  'Africa/Abidjan',
  'Atlantic/Reykjavik',
  'Europe/Rome',
  'Europe/London',
  'Europe/Jersey',
  'America/Jamaica',
  'Asia/Amman',
  'Asia/Tokyo',
  'Africa/Nairobi',
  'Asia/Bishkek',
  'Asia/Bangkok',
  'Asia/Phnom_Penh',
  'Pacific/Tarawa',
  'Pacific/Kanton',
  'Pacific/Kiritimati',
  'Africa/Nairobi',
  'Indian/Comoro',
  'America/Puerto_Rico',
  'America/St_Kitts',
  'Asia/Pyongyang',
  'Asia/Seoul',
  'Asia/Riyadh',
  'Asia/Kuwait',
  'America/Panama',
  'America/Cayman',
  'Asia/Almaty',
  'Asia/Qyzylorda',
  'Asia/Qostanay',
  'Asia/Aqtobe',
  'Asia/Aqtau',
  'Asia/Atyrau',
  'Asia/Oral',
  'Asia/Bangkok',
  'Asia/Vientiane',
  'Asia/Beirut',
  'America/Puerto_Rico',
  'America/St_Lucia',
  'Europe/Zurich',
  'Europe/Vaduz',
  'Asia/Colombo',
  'Africa/Monrovia',
  'Africa/Johannesburg',
  'Africa/Maseru',
  'Europe/Vilnius',
  'Europe/Brussels',
  'Europe/Luxembourg',
  'Europe/Riga',
  'Africa/Tripoli',
  'Africa/Casablanca',
  'Europe/Paris',
  'Europe/Monaco',
  'Europe/Chisinau',
  'Europe/Belgrade',
  'Europe/Podgorica',
  'America/Puerto_Rico',
  'America/Marigot',
  'Africa/Nairobi',
  'Indian/Antananarivo',
  'Pacific/Tarawa',
  'Pacific/Kwajalein',
  'Pacific/Majuro',
  'Europe/Belgrade',
  'Europe/Skopje',
  'Africa/Abidjan',
  'Africa/Bamako',
  'Asia/Yangon',
  'Asia/Ulaanbaatar',
  'Asia/Hovd',
  'Asia/Choibalsan',
  'Asia/Macau',
  'Pacific/Guam',
  'Pacific/Saipan',
  'America/Martinique',
  'Africa/Abidjan',
  'Africa/Nouakchott',
  'America/Puerto_Rico',
  'America/Montserrat',
  'Europe/Malta',
  'Indian/Mauritius',
  'Indian/Maldives',
  'Africa/Maputo',
  'Africa/Blantyre',
  'America/Mexico_City',
  'America/Cancun',
  'America/Merida',
  'America/Monterrey',
  'America/Matamoros',
  'America/Chihuahua',
  'America/Ciudad_Juarez',
  'America/Ojinaga',
  'America/Mazatlan',
  'America/Bahia_Banderas',
  'America/Hermosillo',
  'America/Tijuana',
  'Asia/Kuching',
  'Asia/Singapore',
  'Asia/Kuala_Lumpur',
  'Africa/Maputo',
  'Africa/Windhoek',
  'Pacific/Noumea',
  'Africa/Lagos',
  'Africa/Niamey',
  'Pacific/Norfolk',
  'Africa/Lagos',
  'America/Managua',
  'Europe/Brussels',
  'Europe/Amsterdam',
  'Europe/Berlin',
  'Europe/Oslo',
  'Asia/Kathmandu',
  'Pacific/Nauru',
  'Pacific/Niue',
  'Pacific/Auckland',
  'Pacific/Chatham',
  'Asia/Dubai',
  'Asia/Muscat',
  'America/Panama',
  'America/Lima',
  'Pacific/Tahiti',
  'Pacific/Marquesas',
  'Pacific/Gambier',
  'Pacific/Port_Moresby',
  'Pacific/Bougainville',
  'Asia/Manila',
  'Asia/Karachi',
  'Europe/Warsaw',
  'America/Miquelon',
  'Pacific/Pitcairn',
  'America/Puerto_Rico',
  'Asia/Gaza',
  'Asia/Hebron',
  'Europe/Lisbon',
  'Atlantic/Madeira',
  'Atlantic/Azores',
  'Pacific/Palau',
  'America/Asuncion',
  'Asia/Qatar',
  'Asia/Dubai',
  'Indian/Reunion',
  'Europe/Bucharest',
  'Europe/Belgrade',
  'Europe/Kaliningrad',
  'Europe/Moscow',
  'Europe/Simferopol',
  'Europe/Kirov',
  'Europe/Volgograd',
  'Europe/Astrakhan',
  'Europe/Saratov',
  'Europe/Ulyanovsk',
  'Europe/Samara',
  'Asia/Yekaterinburg',
  'Asia/Omsk',
  'Asia/Novosibirsk',
  'Asia/Barnaul',
  'Asia/Tomsk',
  'Asia/Novokuznetsk',
  'Asia/Krasnoyarsk',
  'Asia/Irkutsk',
  'Asia/Chita',
  'Asia/Yakutsk',
  'Asia/Khandyga',
  'Asia/Vladivostok',
  'Asia/Ust-Nera',
  'Asia/Magadan',
  'Asia/Sakhalin',
  'Asia/Srednekolymsk',
  'Asia/Kamchatka',
  'Asia/Anadyr',
  'Africa/Maputo',
  'Africa/Kigali',
  'Asia/Riyadh',
  'Pacific/Guadalcanal',
  'Asia/Dubai',
  'Indian/Mahe',
  'Africa/Khartoum',
  'Europe/Berlin',
  'Europe/Stockholm',
  'Asia/Singapore',
  'Africa/Abidjan',
  'Atlantic/St_Helena',
  'Europe/Belgrade',
  'Europe/Ljubljana',
  'Europe/Berlin',
  'Arctic/Longyearbyen',
  'Europe/Prague',
  'Europe/Bratislava',
  'Africa/Abidjan',
  'Africa/Freetown',
  'Europe/Rome',
  'Europe/San_Marino',
  'Africa/Abidjan',
  'Africa/Dakar',
  'Africa/Nairobi',
  'Africa/Mogadishu',
  'America/Paramaribo',
  'Africa/Juba',
  'Africa/Sao_Tome',
  'America/El_Salvador',
  'America/Puerto_Rico',
  'America/Lower_Princes',
  'Asia/Damascus',
  'Africa/Johannesburg',
  'Africa/Mbabane',
  'America/Grand_Turk',
  'Africa/Ndjamena',
  'Asia/Dubai',
  'Indian/Maldives',
  'Indian/Kerguelen',
  'Africa/Abidjan',
  'Africa/Lome',
  'Asia/Bangkok',
  'Asia/Dushanbe',
  'Pacific/Fakaofo',
  'Asia/Dili',
  'Asia/Ashgabat',
  'Africa/Tunis',
  'Pacific/Tongatapu',
  'Europe/Istanbul',
  'America/Puerto_Rico',
  'America/Port_of_Spain',
  'Pacific/Tarawa',
  'Pacific/Funafuti',
  'Asia/Taipei',
  'Africa/Nairobi',
  'Africa/Dar_es_Salaam',
  'Europe/Simferopol',
  'Europe/Kyiv',
  'Africa/Nairobi',
  'Africa/Kampala',
  'Pacific/Pago_Pago',
  'Pacific/Tarawa',
  'Pacific/Midway',
  'Pacific/Wake',
  'America/New_York',
  'America/Detroit',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  'America/Indiana/Indianapolis',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Vevay',
  'America/Chicago',
  'America/Indiana/Tell_City',
  'America/Indiana/Knox',
  'America/Menominee',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/North_Dakota/Beulah',
  'America/Denver',
  'America/Boise',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'America/Juneau',
  'America/Sitka',
  'America/Metlakatla',
  'America/Yakutat',
  'America/Nome',
  'America/Adak',
  'Pacific/Honolulu',
  'America/Montevideo',
  'Asia/Samarkand',
  'Asia/Tashkent',
  'Europe/Rome',
  'Europe/Vatican',
  'America/Puerto_Rico',
  'America/St_Vincent',
  'America/Caracas',
  'America/Puerto_Rico',
  'America/Tortola',
  'America/Puerto_Rico',
  'America/St_Thomas',
  'Asia/Bangkok',
  'Asia/Ho_Chi_Minh',
  'Pacific/Efate',
  'Pacific/Tarawa',
  'Pacific/Wallis',
  'Pacific/Apia',
  'Asia/Riyadh',
  'Asia/Aden',
  'Africa/Nairobi',
  'Indian/Mayotte',
  'Africa/Johannesburg',
  'Africa/Maputo',
  'Africa/Lusaka',
  'Africa/Maputo',
  'Africa/Harare'
];

export const tiposTransacao = [
  { id: 1, nome: 'Depósito' },
  { id: 2, nome: 'Saque' },
  { id: 3, nome: 'Depósito Retail' },
  { id: 4, nome: 'Saque Retail' }
];
